export enum NotificationEntityName {
  CHAT = "chat",
  ACTIVITY = "activity",
  MESSAGE = "message",
  DOCUMENT = "document"
}
